<template>
    <div
        class="RankingSorting"
    >
        <button
            :class="[
                'AllUniversitiesToggle',
                { isSelected: !isUniversityRankingEnabled }
            ]"
            type="button"
            @click="toggleUniversityRanking"
        >
            All Universities
        </button>
        <button
            :class="[
                'TopUniversitiesToggle',
                { isSelected: isUniversityRankingEnabled }
            ]"
            type="button"
            @click="toggleUniversityRanking"
        >
            Top Ranked
        </button>
    </div>
</template>


<script lang="ts" setup>
import {  computed } from 'vue';
import { FilterType } from '@studyportals/omnisearch-interfaces';
import { SortMapper, UNIVERSITY_RANKINGS_SORT } from '@app/routing/mappers/SortMapper';
import { useSearchStore } from '@app/stores/useSearchStore';

const searchStore = useSearchStore();

const isUniversityRankingEnabled = computed<boolean>(() => {
    const sortingFilter = searchStore.filtersSelection.find(filter => filter.type === FilterType.SORTING);
    if (!sortingFilter) return false;

    return sortingFilter.values.some(value => value.id === UNIVERSITY_RANKINGS_SORT);
});

const toggleUniversityRanking = async (): Promise<void> => {
    if (isUniversityRankingEnabled.value) {
        await searchStore.removeFilterByType([FilterType.SORTING]);
        return;
    }

    const rankingValue = SortMapper.getInstance().getExtendedFilterValueById(UNIVERSITY_RANKINGS_SORT);
    if (!rankingValue) return;

    const filtersWithoutSorting = searchStore.filtersSelection.filter(filter => filter.type !== FilterType.SORTING);
    searchStore.filtersSelection = [
        ...filtersWithoutSorting,
        {
            type: FilterType.SORTING,
            values: [rankingValue],
            isIndexable: false,
        }
    ];

    await searchStore.setRouteAndLoadData();
};


</script>

<style lang="scss" scoped>
.RankingSorting {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    @include MarginAreas(0, 0,0.5, 0);

    .AllUniversitiesToggle,
    .TopUniversitiesToggle {
        background: $White;
        border: 2px solid $White;
        cursor: pointer;
        text-decoration: none;
        color: $Grey-900;
        border-radius: 0.25rem;
        outline: none;

        @include TextStyle(UiSmallRegular);
        @include PaddingAreas(0.5);

        &.isSelected {
            border-color: $Blue-700;
            background: $Blue-100;
            color: $Blue-700;

            @include TextStyle(UiSmallSemibold);
        }

        &:hover {
            border-color: $Blue-700;
        }
    }
}
</style>